export const moduleIndex = [
  {
    id: 'human-capability-edition',
    name: 'Human Capability Edition',
    summary: 'Understand capabilities and follow development over time',
  },
  { id: 'talent', name: 'Noetivra Talent', summary: 'Connect role requirements with demonstrated skills' },
  { id: 'clinical', name: 'Noetivra Clinical', summary: 'Review the clinical picture and its supporting knowledge' },
  { id: 'research', name: 'Noetivra Research', summary: 'Help researchers connect ideas' },
  { id: 'collaboration', name: 'Noetivra Collaboration', summary: 'Build a shared view across organizations' },
]

export const workspaceViews = [
  'Knowledge maps',
  'Comparison views',
  'Assessment profiles',
  'Timelines',
  'Review tools',
]

export const capabilityProgression = ['Assess', 'Explain', 'Recommend', 'Support', 'Reassess', 'Advance']

export const talentExample = [
  {
    requirement: 'Planning',
    demonstrated: 'Created a workable schedule and identified dependencies.',
    followUp: 'Explore their response to a missed milestone.',
  },
  {
    requirement: 'Budget management',
    demonstrated: 'Described tracking project expenses.',
    followUp: 'Verify whether they owned the budget.',
  },
  {
    requirement: 'Handling setbacks',
    demonstrated: 'Explained a recovery plan and its tradeoffs.',
    followUp: 'Clarify their personal contribution.',
  },
]

export const systemFit = [
  {
    name: 'Semantic Knowledge Platform',
    role: 'Connects and governs knowledge, sources, concepts, and relationships.',
    link: '/semantic-knowledge',
  },
  {
    name: 'Human Capability Platform',
    role: 'Provides capability assessment methods, interpretation rules, and development pathways.',
    link: '/human-capability',
  },
  {
    name: 'Noetivra',
    role: 'Makes these resources visible and usable through interactive views, assessments, and workflows.',
    link: null,
  },
]
